import { EvalModelIdSchema, EvalWorkflowTypeSchema } from '@root/domain/schemas/evals/eval-config.schema';
import { EVAL_CONFIG_STARTERS, type EvalConfigStarterId } from '@root/helpers/constants';
import { z } from 'zod';

export const createEvalConfigFormSchema = z.object({
  copy_from: z.enum(EVAL_CONFIG_STARTERS.map(({ id }) => id) as [EvalConfigStarterId, ...EvalConfigStarterId[]]),
  name: z.string().trim().min(1, { message: 'Name is required' }),
  description: z
    .string()
    .trim()
    .optional()
    .transform((v) => (v && v.length > 0 ? v : undefined)),
  workflow_type: z.enum(EvalWorkflowTypeSchema.options, {
    errorMap: () => ({ message: 'Workflow type is required' }),
  }),
  model_id: EvalModelIdSchema,
});
